import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "./database.types";

/**
 * Supabase Service-Role-Client für serverseitige Aufrufe (API-Routen,
 * Server-Components, Repositories). Umgeht Row Level Security – nur
 * server-side verwenden, niemals Anon/Browser-exposed.
 *
 * Wir cachen den Client als Modul-Singleton, damit jede Lambda-Instanz
 * nur einen Connection-Pool aufbaut.
 */

export type SupabaseAdminClient = SupabaseClient<Database>;

let _client: SupabaseAdminClient | null = null;

export function getSupabaseAdmin(): SupabaseAdminClient {
  if (_client) return _client;

  const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
  const serviceKey = process.env.SUPABASE_SERVICE_ROLE_KEY;

  if (!url || !serviceKey) {
    throw new Error(
      "Supabase ist nicht konfiguriert (NEXT_PUBLIC_SUPABASE_URL / SUPABASE_SERVICE_ROLE_KEY fehlen). " +
        "Setze die Variablen in Vercel → Settings → Environment Variables.",
    );
  }

  _client = createClient<Database>(url, serviceKey, {
    auth: {
      autoRefreshToken: false,
      persistSession: false,
      detectSessionInUrl: false,
    },
    global: {
      headers: { "x-application-name": "dmd-studio-website" },
    },
  });

  return _client;
}

/**
 * Prüft, ob Supabase überhaupt konfiguriert ist – ohne den Client zu
 * initialisieren. So kann die Repository-Factory entscheiden, ob sie
 * den Supabase-Adapter oder das InMemory-Fallback nutzt.
 */
export function isSupabaseConfigured(): boolean {
  return !!(
    process.env.NEXT_PUBLIC_SUPABASE_URL &&
    process.env.SUPABASE_SERVICE_ROLE_KEY
  );
}
